import { render, staticRenderFns } from "./MyDocumentsView.vue?vue&type=template&id=55ce85ff&"
import script from "./MyDocumentsView.vue?vue&type=script&lang=js&"
export * from "./MyDocumentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports